import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoggingService } from '../../../../modules/src/lib/core/services/logging.service';
import { AlertMessageStore } from '../../../../modules/src/lib/core/stores/alert-message.store';
import { SeverityTypeEnum } from '../../../../modules/src/lib/core/enums/severity-type.enum';
import { AlertMessageFactory } from '../../../../modules/src/lib/core/factories/alert-message.factory';
import { EventApiController } from '../api-controllers/event.api-controller';
import { AlertContextEnum } from '../../../../modules/src/lib/core/enums/alert-context.enum';
import { SearchQuery } from '../../../../../../server/dist/angular/server/src/microservice/models/search-query.model';
import { SortOrderEnum } from '../../../../../../server/dist/angular/server/src/indexing/enums/sort-order.enum';
import { EventIndexModel } from '../../../../../../common/src/index-models/event.index-model';


@Injectable({
  providedIn: 'root',
})
export class EventStore {
  public openQuickCalculation$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private latests: BehaviorSubject<EventIndexModel<any>[]> = new BehaviorSubject<EventIndexModel<any>[]>([]);

  public constructor(private readonly eventApiController: EventApiController,
                     private readonly loggingService: LoggingService,
                     private readonly alertMessageStore: AlertMessageStore) {
  }

  public listLatest(): Observable<EventIndexModel<any>[]> {
    this.refreshLatests();

    return this.latests;
  }

  public async refreshLatests(): Promise<void> {
    this.loggingService.debug('Refreshing latest events', {});

    try {
      const searchQuery = new SearchQuery();
      searchQuery.setSort('createdAt', SortOrderEnum.Descending);

      const events = await this.eventApiController.search(searchQuery);

      this.latests.next(events.results ?? []);
    } catch (error) {
      this.loggingService.error('[event-store] - There was an error retrieving the latest events', { error });

      this.alertMessageStore.saveAll(AlertMessageFactory.create(error, SeverityTypeEnum.Error, AlertContextEnum.Global));
    }
  }

  public async openQuickCalculation(): Promise<void> {
    this.openQuickCalculation$.next(true);
  }
}
